import { useState, useCallback } from 'react';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { updateRenderingType } from '../../../../utils/services/complexDocumentsAPI';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../../../context/complexDocumentContext';
import { useArtboardContext, CONTEXT_KEYS } from '../../../../context/complexArtboardContext';
import { DESIGN_AREA_SETTINGS_TAB } from '../../../SidebarMenu/translationValues';

const NAMESPACES = ['DESIGN_AREA_SETTINGS_TAB'];

const RENDERING_TYPES = {
  DIGITAL: "digital",
  PRINT_RGB: "print_rgb",
  PRINT_CMYK: "print_cmyk",
};

const renderingTypeMap = {
  0: RENDERING_TYPES.DIGITAL,
  1: RENDERING_TYPES.PRINT_RGB,
  2: RENDERING_TYPES.PRINT_CMYK,
};

export const usePdfQualitySettings = () => {
  const { t } = useTranslation(NAMESPACES);
  const documentIdSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID], []);
  const [documentId, store] = useDocumentContext(documentIdSelector, 'usePdfQualitySettings');
  
  const renderingTypeSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.RENDERING_TYPE], []);
  const [renderingType] = useDocumentContext(renderingTypeSelector, 'usePdfQualitySettings');
  
  const accessibilitySelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_ACCESSIBLE], []);
  const [accessibilityEnabled] = useDocumentContext(accessibilitySelector, 'usePdfQualitySettings');
  
  const isOpenDesignSelector = useCallback((store) => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign, updateArtboard] = useArtboardContext(isOpenDesignSelector, 'usePdfQualitySettings');
  
  const [pdfQuality, setPdfQuality] = useState(renderingType);

  const handleOpenDesign = useCallback(() => {
    updateArtboard({
      [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: true
    });
  }, [updateArtboard]);

  const onPdfQualityChange = useCallback(
    async value => {
      if (isOpenDesign) {
        handleOpenDesign();
        return;
      }
      const showErrorMessage = () => {
        if (value) {
          return message.error(
            t(
              DESIGN_AREA_SETTINGS_TAB.PDF_QUALITY_CHANGE_FAIL_ERROR_MESSAGE.key,
              DESIGN_AREA_SETTINGS_TAB.PDF_QUALITY_CHANGE_FAIL_ERROR_MESSAGE.value,
            )
          );
        }
      };
      try {
        const response = await updateRenderingType(documentId, renderingTypeMap[value]);
        if (response?.statusCode === 847) {
          store.set({
            [COMPLEX_DOCUMENT_CONTEXT_KEYS.RENDERING_TYPE]: value,
          });
          setPdfQuality(value);
          if (value === 1 || value === 2) {
            store.set({
            [COMPLEX_DOCUMENT_CONTEXT_KEYS.IS_ACCESSIBLE]: false,
          });
          }
        } else {
          showErrorMessage();
        }
      } catch (e) {
        showErrorMessage();
      }
    },
    [documentId, isOpenDesign, handleOpenDesign, store, t],
  );

  return {
    pdfQuality,
    onPdfQualityChange,
  };
};


